export default "__VITE_ASSET__BZBHRxOP__"